import type { Filter } from "@1js/pl-card-components";
import { PromptFilters, PromptFiltersMobile } from "@1js/pl-card-components";
import * as React from "react";
import { useIsSmallScreen } from "../../hooks/useIsSmallScreen";

type Props = {
  filters: Filter[];
  selectedFilters: Record<string, string[]>;
  isLoading?: boolean;
  onFilterChanged: (
    selectedValues: Record<string, string[]>,
    filters: Filter[]
  ) => void;
  onOpenChanged: (isOpen: boolean, filters: Filter[]) => void;
  onCleared: () => void;
  isMetaOsV2?: boolean;
  disabledFilters?: Record<string, boolean>;
  selectedFilterValue?: string | null;
};

export const Filters: React.FC<Props> = React.memo(
  ({
    filters,
    selectedFilters,
    isLoading,
    isMetaOsV2,
    onFilterChanged,
    onOpenChanged,
    onCleared,
    disabledFilters,
    selectedFilterValue,
  }) => {
    const isMobile = useIsSmallScreen();
    return (
      <>
        {!isMobile && (
          <PromptFilters
            appearance="web"
            tab="all"
            filters={filters}
            defaultSelectedFilters={selectedFilters}
            selectedFilters={selectedFilters}
            isLoading={isLoading}
            onFilterChanged={onFilterChanged}
            onOpenChanged={onOpenChanged}
            isMetaOsV2={isMetaOsV2}
            disabledFilters={disabledFilters}
            selectedFilterValue={selectedFilterValue}
          />
        )}
        {isMobile && (
          <PromptFiltersMobile
            filters={filters}
            selectedFilters={selectedFilters}
            onApplyFiltered={onFilterChanged}
            isLoading={isLoading}
            onOpenChanged={onOpenChanged}
            onCleared={onCleared}
          />
        )}
      </>
    );
  }
);
Filters.displayName = "AllPromptsFilters";
